import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-time-in-outs',
  templateUrl: './time-in-outs.component.html',
  styleUrls: ['./time-in-outs.component.css']
})
export class TimeInOutsComponent implements OnInit {
    argType;

    argValue;

    public itemsListTimeInOuts: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadTimeInOuts() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListTimeInOuts = await this.datatask.Post(147, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadTimeInOuts();
    }

    ngOnInit() {
        this.init();
    }
}
